module.exports = __webpack_public_path__ + "jab/media/title.9f808e8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/title.svg
// module id = 113
// module chunks = 0